export const ASSUME_TENANT_HEADER = 'X-Assume-Tenant-Id';
export const SUPPORT_MODE_HEADER = 'X-Support-Mode';
export const SUPPORT_TENANT_STORAGE_KEY = 'lp.support.assumedTenantId';
